import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Building2 } from "lucide-react";
import { departmentService } from "../api";
import { DepartmentForm } from "../components/DepartmentForm";
import type { DepartmentCreateRequest } from "../types";

export default function DepartmentCreatePage() {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(payload: DepartmentCreateRequest) {
    setBusy(true);
    setError(null);
    try {
      await departmentService.create(payload);
      navigate("/admin/departments");
    } catch (e: any) {
      setError(e?.response?.data?.message ?? e?.message ?? "Failed to create department.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6">
      <Link
        to="/admin/departments"
        className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-700 hover:underline"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Departments
      </Link>

      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
          <Building2 className="h-5 w-5" />
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">New Department</h1>
      </div>

      {error && (
        <div className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700">
          <strong>Error:</strong> {error}
        </div>
      )}

      <div className="rounded-2xl border bg-white p-6 shadow-sm">
        <DepartmentForm busy={busy} onSubmit={handleSubmit} />
      </div>
    </div>
  );
}
